export * from "@agrigate/shared-web-ui/lib/stores/session";

import { atom } from "jotai";

export interface ImpersonationState {
    impersonatedUserId: string;
    /** Token of the original (pre-impersonation) user, restored when switching back */
    prevToken: string;
}

/**
 * Set once an admin has switched to another user's session, cleared on switching back.
 * While set, analytics keeps attributing events to the original admin instead of the switched-to user.
 */
export const impersonationStateAtom = atom<ImpersonationState | null>(null);
